// Event Cohost management
import { doc, setDoc, getDoc, deleteDoc, collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';

/**
 * Add a cohost to an event
 */
export const addEventCohost = async (
  eventId,
  userId,
  addedBy
) => {
  const cohostRef = doc(db, 'events', eventId, 'cohosts', userId);
  await setDoc(cohostRef, {
    eventId,
    userId,
    addedBy,
    addedAt: new Date(),
  });
};

/**
 * Remove a cohost from an event
 */
export const removeEventCohost = async (
  eventId,
  userId
) => {
  await deleteDoc(doc(db, 'events', eventId, 'cohosts', userId));
};

/**
 * Get all cohosts for an event
 */
export const getEventCohosts = async (eventId) => {
  const cohostsSnapshot = await getDocs(collection(db, 'events', eventId, 'cohosts'));
  const cohosts: any[] = [];
  
  cohostsSnapshot.forEach((doc) => {
    const data = doc.data();
    cohosts.push({
      eventId: data.eventId,
      userId: data.userId,
      addedBy: data.addedBy,
      addedAt: data.addedAt?.toDate() || new Date(),
    });
  });
  
  return cohosts;
};

/**
 * Check if user is event cohost
 */
export const isEventCohost = async (
  eventId,
  userId
) => {
  const cohostDoc = await getDoc(doc(db, 'events', eventId, 'cohosts', userId));
  return cohostDoc.exists();
};

